import { fmt, type Plan } from '../../lib/geo'
import { PLAN_ICON } from '../../lib/content'
import { ActivityIcon } from '../ui/Icon'

/** Glass card for the selected plan, with a working "Ask to join" toggle. */
export function PlanSheet({ plan, requested, onToggle }: { plan: Plan; requested: boolean; onToggle: () => void }) {
  const p = plan
  const left = p.spots - p.filled
  return (
    <div className="ov sheetp glass" aria-live="polite">
      <div className="sheet-in" key={p.id}>
      <div className="sheet-top">
        <span className="ico"><ActivityIcon name={PLAN_ICON[p.id] ?? 'chai'} /></span>
        <div className="min0"><h3>{p.title}</h3><div className="sub">{p.venue.name}, {p.venue.area}</div></div>
      </div>
      <div className="chips">
        <span className="chip">{fmt(p.start)}</span>
        {p.wf && <span className="chip wf">Women-first</span>}
        <span className="chip">{left > 0 ? `${left} ${left === 1 ? 'spot' : 'spots'} left` : 'Full, join the waitlist'}</span>
      </div>
      <dl className="kv">
        <dt>Host</dt><dd>{p.host}</dd>
        <dt>Level</dt><dd>{p.level}</dd>
        <dt>Cost</dt><dd>{p.cost}</dd>
        <dt>Where</dt><dd className="mono where">{p.venue.lat.toFixed(4)}, {p.venue.lng.toFixed(4)}</dd>
      </dl>
      <button type="button" className={`btn ${requested ? 'clear' : 'gold'}`} onClick={onToggle}>
        {requested ? `Requested. Waiting for ${p.host}` : left > 0 ? 'Ask to join' : 'Join the waitlist'}
      </button>
      <div className="note">{requested ? 'Tap again to cancel your request.' : `Exact details unlock after ${p.host} approves you.`}</div>
      </div>
    </div>
  )
}
